import Styles from './InstagramReelPreview.module.scss'
import { LikeIcon, CommentIcon, ShareIcon, MusicIcon } from '../InstagramPreview/icons'
import { MoreDots } from 'blaze-ui/icons/24'

export const Actions = () => {
  return (
    <div className={Styles.actions}>
      <div className={Styles.action}>
        <LikeIcon />
        <span>223</span>
      </div>
      <div className={Styles.action}>
        <CommentIcon />
        <span>23</span>
      </div>
      <div className={Styles.action}>
        <ShareIcon />
        <span>3</span>
      </div>
      <div className={Styles.action}>
        <MoreDots />
      </div>
      <div className={Styles.action}>
        <MusicIcon />
      </div>
    </div>
  )
}
